import { useLang } from 'hooks/lang';

import { Card, Row } from 'components/Blocks';
import { UserAvatarGroup } from 'components/UserAvatar';
import { EntityStatusTag } from 'components/Entities';

import { LockIcon } from 'components/Icons';

import { useProjectProfile } from '../context';

export function NoInvoiceAccess() {
  const { t } = useLang();
  const {
    project: { invoice },
  } = useProjectProfile();

  return (
    <Card flow="column" alignItems="center" className="mx-auto mt-20 max-w-4xl">
      <Row gap="2" justifyContent="center">
        <LockIcon color="primary" />

        <h6>{t('invoice-access-restricted')}</h6>
      </Row>

      <span className="text-center">{t('restricted-explanation')}</span>

      <Row justifyContent="center">
        <UserAvatarGroup users={[invoice.owner, invoice.subOwner]} />

        <EntityStatusTag
          target="invoiceControl"
          status={invoice.status}
          round={false}
          size="medium"
        />
      </Row>
    </Card>
  );
}
